import md5 from 'blueimp-md5';

export const toAmount = (value: string | number) => {
  if (!value || !Number.isFinite(+value)) return '';
  let val = value.toString().match(/^[0-9]*\.([0-9]{0,2})|^[0-9]*/)[0];
  if (val[0] === '.') {
    val = '0.';
  }
  if (val[0] === '0' && val.indexOf('.') === -1) {
    val = '0.';
  }
  return val;
};

export const toInt = (value: string | number) => {
  console.log(value, value.toString().match(/(\d+)/)?.[0]);

  return value.toString().match(/(\d+)/)?.[0] ?? '';
};

export const isValidMobile = (v: string) => {
  return /^1\d{10}$/.test(v);
};

export const SecureStringGenerator = (() => {
  // 获取浏览器指纹
  const getFingerprint = () => {
    const navigatorInfo = [
      navigator.userAgent,
      navigator.language,
      screen.width,
      screen.height,
      screen.colorDepth,
      navigator.platform,
      navigator.hardwareConcurrency, // CPU核心数
    ];
    return navigatorInfo.join('-'); // 合并信息
  };

  // 基于浏览器指纹生成加密字符串
  const generate = (length) => {
    const fingerprint = getFingerprint();
    let hash = 0;

    // 简单哈希算法（字符串转数值）
    for (let i = 0; i < fingerprint.length; i++) {
      const char = fingerprint.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash |= 0; // 保证为32位整数
    }

    // 将哈希值转换为字符串
    let result = '';
    while (result.length < length) {
      hash = (hash * 31) & 0xffffffff; // 更新哈希值
      const charCode = (Math.abs(hash) % 94) + 33; // 映射到可打印字符范围 [33, 126]
      result += String.fromCharCode(charCode);
    }

    return md5(result.slice(0, length)); // 返回指定长度的字符串
  };

  return { generate };
})();
